import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import {edit, item, listActivationType, listRoleType, listStatus, resetPassword} from '../../lib/api/user';
import {list as listClub} from "../../lib/api/club";
import {useNavigate} from "react-router-dom";

const PasswordResetForm = ({ hasLabel }) => {
  // State
  const queryParams = new URLSearchParams(location.search);
  const activation_guide = queryParams.get('activation_guide'); // <-- OVDJE se čita iz URL-a
  const navigate = useNavigate();

  const [activationGuide, setActivationGuide] = useState(null);

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });

  useEffect(() => {
    if (activation_guide) {
      setActivationGuide(activation_guide);
    }
  }, [activation_guide]);

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();

    if (formData.password.length < 6) {
      toast.error('Lozinka mora imati najmanje 6 karaktera.', {
        theme: 'colored'
      });
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error('Lozinka i potvrda lozinke se ne podudaraju.', {
        theme: 'colored'
      });
      return;
    }

    try {

      console.log('activation_guide',activation_guide);
      const options = {
        _password: formData.password,
        _confirmPassword: formData.confirmPassword
      };

      if (activation_guide != null) {
        options.activation_guide = activation_guide;
      }

      const row = await resetPassword(options);
      localStorage.clear();
      toast.success('Lozinka je promjenjena.');
      navigate('/authentication/simple/login');

    } catch (error) {
      console.log(error)
      toast.error("Došlo je do greške")
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form
      className={classNames('mt-3', { 'text-left': hasLabel })}
      onSubmit={handleSubmit}
    >
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>New Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'New Password' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Confirm Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Confirm Password' : ''}
          value={formData.confirmPassword}
          name="confirmPassword"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Button
        type="submit"
        className="w-100"
        disabled={!formData.password || !formData.confirmPassword}
      >
        Set password
      </Button>
    </Form>
  );
};

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default PasswordResetForm;
